__turbopack_context__.v({
  "active": "index-module-scss-module__Iunhlq__active",
  "attachment_component": "index-module-scss-module__Iunhlq__attachment_component",
  "container": "index-module-scss-module__Iunhlq__container",
  "fakeFileInput": "index-module-scss-module__Iunhlq__fakeFileInput",
  "fileInput": "index-module-scss-module__Iunhlq__fileInput",
  "withFile": "index-module-scss-module__Iunhlq__withFile",
});
